import { onDomReady } from "../services/on-dom-ready";
import ModalBlocked from "../components/modal/modal-blocked";

const imagePreviewPromise = new Promise((resolve, reject) => {
  onDomReady.then(() => {
      let element = document.getElementById("image-full");
      if (element) {
        let popup = ModalBlocked.get(element);
        resolve(popup);
      } else {
        reject("There is no #image-full element on page");
      }
    });
});

const showFullImage = url => {
  imagePreviewPromise.then(popup => {
    let image = popup.root.querySelector("[data-image]");
    image.src = url;
    popup.open();
  });
};

export { showFullImage };